import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TThunkAction } from '../../types/redux';
import { getObjectInfo } from '../../selectors/objectInfo';
import { trackInformerOpen } from '../../containers/RatingInformationModal/tracking';

export enum EModalsActionTypes {
  ToggleRatingInfoModal = 'modals/toggleRatingInfoModal',
}

export type TToggleRatingInfoModal = ITypedReduxAction<EModalsActionTypes.ToggleRatingInfoModal, boolean>;

export const toggleRatingInfoModal = actionGenerator<EModalsActionTypes.ToggleRatingInfoModal, boolean>(
  EModalsActionTypes.ToggleRatingInfoModal,
);

export const openRatingInfoModal = (): TThunkAction => (dispatch, getState, config) => {
  const state = getState();
  const deviceType = config.custom.deviceType;
  const { objectId: objectId } = getObjectInfo(state);

  trackInformerOpen({ deviceType, objectId });
  dispatch(toggleRatingInfoModal(true));
};

export type TModalsActions = TToggleRatingInfoModal;
